/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_Verify_Already_VerifiedInputs */

const en_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`University email verified`)
};

const de_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitaets-E-Mail verifiziert`)
};

const fr_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail universitaire verifie`)
};

const es_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo universitario verificado`)
};

const it_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email universitaria verificata`)
};

const nl_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universiteitsemail geverifieerd`)
};

const pl_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail uniwersytecki zweryfikowany`)
};

const fi_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yliopiston sahkoposti vahvistettu`)
};

const da_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitetsmail bekræftet`)
};

const sv_student_verify_already_verified = /** @type {(inputs: Student_Verify_Already_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Universitetsmejl verifierad`)
};

/**
* | output |
* | --- |
* | "University email verified" |
*
* @param {Student_Verify_Already_VerifiedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const student_verify_already_verified = /** @type {((inputs?: Student_Verify_Already_VerifiedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_Verify_Already_VerifiedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_student_verify_already_verified(inputs)
	if (locale === "fr") return fr_student_verify_already_verified(inputs)
	if (locale === "es") return es_student_verify_already_verified(inputs)
	if (locale === "it") return it_student_verify_already_verified(inputs)
	if (locale === "nl") return nl_student_verify_already_verified(inputs)
	if (locale === "pl") return pl_student_verify_already_verified(inputs)
	if (locale === "fi") return fi_student_verify_already_verified(inputs)
	if (locale === "da") return da_student_verify_already_verified(inputs)
	if (locale === "sv") return sv_student_verify_already_verified(inputs)
	return en_student_verify_already_verified(inputs)
});